import fetchIntercept from "fetch-intercept";
import Keycloak from "keycloak-js";

export const requestInterceptor = async (
  url: string,
  config: any,
  keycloakAdapter: Keycloak,
  routesWithAuthToken: string[]
) => {
  if (routesWithAuthToken.every((pagePath) => url.indexOf(pagePath) === -1)) {
    return [url, config];
  }

  const res = await handleAuthHeader(keycloakAdapter);
  if (res) {
    const headers = {
      ...(config ? config.headers : {}),
      ...res
    };
    return [url, { ...config, headers }];
  }

  return [url, config];
};

export const handleAuthHeader = async (keycloakAdapter: Keycloak) => {
  try {
    if (keycloakAdapter.isTokenExpired()) {
      await keycloakAdapter.updateToken(5);
    }

    if (keycloakAdapter.token) {
      // Insert auth token
      return {
        Authorization: `Bearer ${keycloakAdapter.token}`
      };
    }
  } catch (error) {
    console.error("Couldn't refresh token ", error);
    keycloakAdapter.login();
  }
  return Promise.reject();
};

export function registerFetchInterceptor(keycloakAdapter: Keycloak, routesWithAuthToken: string[]) {
  return fetchIntercept.register({
    async request(url, config) {
      return requestInterceptor(url, config, keycloakAdapter, routesWithAuthToken);
    }
  });
}
